import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Handler from "../../../Helpers/Components/Handler";
import { toast } from "react-toastify";
import White from "../../../Assets/images/white-bg.avif"
import { setCustomer, setStep } from "../../../Reducer/customerSlice";
import NextPrev from "../../../Helpers/Components/NextPrev";
import Compressor from 'compressorjs';

const Photo = (props) => {
    const [loading, setLoading] = useState(false)
    const customer = useSelector(state => state?.customer?.customer)
    const dispatch = useDispatch()
    const setSteps = () => {
        props?.page?.other ? dispatch(setStep(7)) : (props?.page?.kyc ? dispatch(setStep(6)) : dispatch(setStep(5)))
    }
    const checkFileSize = async (file, fieldName) => {
        if (file.size > 4.5 * 1024 * 1024) {
            toast.error('Compressed image size exceeds 4.5 MB.');
        } else {
            const formData = new FormData()
            formData?.append('photo', file)
            const response = await Handler({ data: formData, url: `/customer/details/image/${props?.customerId}`, method: 'patch', headers: { 'Content-Type': 'multipart/form-data' } })
            if (response?.success) {
                dispatch(setCustomer({ photo: file, profile: URL.createObjectURL(file) }))
            } else {
                toast.error("Unable to upload image")
            }
            setLoading(false)

        }
    };
    const compressImage = (file, fieldName) => {
        new Compressor(file, {
            quality: 0.9,
            convertSize: 1 * 1024 * 1024,
            success(result) {
                checkFileSize(result, fieldName);
            },
            error(err) {
                toast.error(err.message);
                setLoading(false)
            },
        });
    };
    const handleImage = (event) => {
        setLoading(true)
        if (event.target.files[0]) {
            compressImage(event.target.files[0], [event.target.name]);
        }
    };
    return (
        <React.Fragment>
            <div className="row">
                <div className="col-md-6 col-xl-4">
                    <label className="form-label"> Profile Photo </label>
                    <div className="main-div mb-3">
                        <div className="btn-div">
                            {loading ? "" : <label htmlFor='profile' className="me-2 upload-btn">Upload</label>}
                            <button className="btn-warning btn btn-sm" onClick={() => { if (customer?.profile) { props?.setChosen(customer?.profile); props?.setProof(true) } }}>View</button>
                        </div>
                        <img src={customer?.profile || White} alt="Profile" className="kycPhotoImg" />
                    </div>
                    <input type="file" accept="image/*" className="d-none" name="profile" id='profile' disabled={loading}
                        onChange={(event) => handleImage(event)}
                    />
                </div>
            </div>
            <NextPrev step={8} setStep={setSteps} last={7} loading={loading} />
            <div className="text-center mt-4"><button className="btn btn-theme" disabled={loading} onClick={() => { if (customer?.profile) { props?.setPreview(true) } else { toast.error("Customer photo is required") } }}>{loading ? <i className="fa-solid fa-spinner fa-spin"></i> : "Preview"}</button></div>
        </React.Fragment>
    )
}

export default Photo